import { BROWSER_OPT_IN_FEATURE_BLOCKS, BROWSER_OPT_IN_FEATURE_NODES } from './constant.browser.mjs';
import { HEADLESS_OPT_IN_FEATURE_BLOCKS, HEADLESS_OPT_IN_FEATURE_NODES } from './constant.headless.mjs';

const OPT_IN_FEATURE_NODES = {
  ...HEADLESS_OPT_IN_FEATURE_NODES,
  ...BROWSER_OPT_IN_FEATURE_NODES
};
const OPT_IN_FEATURE_BLOCKS = {
  ...HEADLESS_OPT_IN_FEATURE_BLOCKS,
  ...BROWSER_OPT_IN_FEATURE_BLOCKS
};

export { OPT_IN_FEATURE_BLOCKS, OPT_IN_FEATURE_NODES };
//# sourceMappingURL=constant.mjs.map
